import React from 'react'
import HoverableLink from 'src/components/HoverableLink/HoverableLink'
import { useTranslate } from 'src/localization/Trns'
import { css } from 'styled-components'

interface CustomerSupportCodeProps {
  customerSupportCode?: number
  handleClick: () => void
  loading?: boolean
}

const CustomerSupportCode: React.FC<CustomerSupportCodeProps> = ({
  customerSupportCode,
  handleClick,
  loading,
}): React.ReactElement => {
  const translate = useTranslate()

  return customerSupportCode !== undefined ? (
    <span>{customerSupportCode}</span>
  ) : (
    <div>
      <span
        css={css`
          margin-right: 8px;
        `}
      >
        {'∗∗∗∗∗∗'}
      </span>
      <HoverableLink
        onClick={handleClick}
        underline
        disabled={loading}
        ariaLabelSource={'Reveal code'}
      >
        {translate('Reveal code')}
      </HoverableLink>
    </div>
  )
}

export default CustomerSupportCode
